import axiosInstance from "../interceptor/interceptor";
import applicantDetailsDictionary from "../dictionary/applicantDetailsDictionary";

const applicantDetailsServices = {
  verifyPan: (payload: any) =>
    axiosInstance.post(applicantDetailsDictionary.verifyPan(), payload),
  aadhaarApplication: (payload: any) =>
    axiosInstance.post(
      applicantDetailsDictionary.aadhaarApplication(),
      payload
    ),
  verifyAadhaarApplication: (payload: any) =>
    axiosInstance.post(
      applicantDetailsDictionary.verifyAadhaarApplication(),
      payload
    ),
  applicantIssueFile: (trackingId: string) =>
    axiosInstance.get(
      applicantDetailsDictionary.applicantIssueFile(trackingId)
    ),
  createApplicant: (payload: any) =>
    axiosInstance.post(applicantDetailsDictionary.createApplicant(), payload),

  digilockerApplication: (payload: any) =>
    axiosInstance.post(applicantDetailsDictionary.digilockerApplication(), payload),
};

export default applicantDetailsServices;
